import { render, staticRenderFns } from "./LoopingBG.vue?vue&type=template&id=b6f6aa74&lang=pug&"
import script from "./LoopingBG.vue?vue&type=script&lang=ts&"
export * from "./LoopingBG.vue?vue&type=script&lang=ts&"
import style0 from "./LoopingBG.vue?vue&type=style&index=0&id=b6f6aa74&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports